import { PageBannerModule } from 'Src/ng2/shared/components/page-banner/page-banner.module';
import { MaintenanceModeModule } from './../../../shared/components/maintenance-mode/maintenance-mode.module';
import { NetworkLeftSideNavModule } from './../../network-left-side-nav/network-left-side-nav.module';
import { NetworkStandardLayoutComponent } from './network-standard-layout.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NvSubNavModule } from '../../../shared/components/nv-sub-nav/nv-sub-nav.module';

@NgModule({
  declarations: [NetworkStandardLayoutComponent],
  imports: [CommonModule, RouterModule, NetworkLeftSideNavModule, MaintenanceModeModule, PageBannerModule, NvSubNavModule],
  exports: [NetworkStandardLayoutComponent],
  providers: [],
  schemas: [],
})
export class NetworkStandardLayoutModule {}
